import React from 'react'
import Layout from '../../Layout'
import DeliveredOrderPeykContainer from '../../../../Components/OrdersPeykPart/DeliveredOrderPeykContainer/DeliveredOrderPeykContainer'

const OrderDeliveredPeyk = () => {
  return (
    <Layout>
      <DeliveredOrderPeykContainer/>
    </Layout>
  )
}

export default OrderDeliveredPeyk